import { staffApi } from '@/core/api/staff'

export const {
  useAddStaffMutation,
  useGetStaffQuery,
  useGetStaffsQuery,
  useLazyGetStaffsQuery,
  useGetStaffsByEstablishmentQuery,
  useLazyGetStaffsByEstablishmentQuery,
  useRejectLicenseMutation,
} = staffApi
